var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreventivoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 27,
    viewBox: "0 0 36 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.1398 21.459H12.0074C10.5483 21.459 9.36523 22.6426 9.36523 24.1023C9.36523 25.5609 10.5483 26.7445 12.0074 26.7445H33.1398C34.5983 26.7445 35.7814 25.5609 35.7814 24.1023C35.7814 22.6432 34.5983 21.459 33.1398 21.459Z",
    fill: "#00A551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.1398 10.9414H12.0074C10.5483 10.9414 9.36523 12.1245 9.36523 13.5841C9.36523 15.0433 10.5483 16.2263 12.0074 16.2263H33.1398C34.5983 16.2263 35.7814 15.0433 35.7814 13.5841C35.7814 12.125 34.5983 10.9414 33.1398 10.9414Z",
    fill: "#00A551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0074 5.70875H33.1398C34.5983 5.70875 35.7814 4.5257 35.7814 3.06601C35.7814 1.60631 34.5983 0.423828 33.1398 0.423828H12.0074C10.5483 0.423828 9.36523 1.60688 9.36523 3.06601C9.36523 4.52514 10.5483 5.70875 12.0074 5.70875Z",
    fill: "#00A551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.46347 5.7724C4.94476 5.7724 6.14557 4.57159 6.14557 3.0903C6.14557 1.60902 4.94476 0.408203 3.46347 0.408203C1.98219 0.408203 0.781372 1.60902 0.781372 3.0903C0.781372 4.57159 1.98219 5.7724 3.46347 5.7724Z",
    fill: "#00A551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.46346 16.2659C4.94443 16.2659 6.145 15.0653 6.145 13.5844C6.145 12.1034 4.94443 10.9028 3.46346 10.9028C1.98249 10.9028 0.781921 12.1034 0.781921 13.5844C0.781921 15.0653 1.98249 16.2659 3.46346 16.2659Z",
    fill: "#00A551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.46347 26.7841C4.94476 26.7841 6.14557 25.5833 6.14557 24.102C6.14557 22.6207 4.94476 21.4199 3.46347 21.4199C1.98219 21.4199 0.781372 22.6207 0.781372 24.102C0.781372 25.5833 1.98219 26.7841 3.46347 26.7841Z",
    fill: "#00A551"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreventivoIcon);
export default __webpack_public_path__ + "static/media/preventivo-icon.746acbd9aeebf7a56d25d7ad82967118.svg";
export { ForwardRef as ReactComponent };